import React from "react";
import { Link } from "react-router-dom";
import "../styles/saas.css";

export default function PaymentSuccessPage() {
  return (
    <div className="saas-page saas-auth">
      <h1>Payment successful</h1>
      <p>Your subscription is now active.</p>
      <Link to="/dashboard" className="saas-btn saas-btn--primary">Go to dashboard</Link>
    </div>
  );
}
